import { CardSizes, getSizeClasses } from '@/components/CardFace/CardFace';
import card from '../../../../assets/cardHolder.png';

const CardHolder = ({ size }: { size: CardSizes }) => {
  const sizeClasses = getSizeClasses(size);
  return <img className={`aspect-[60/82] ${sizeClasses}`} src={card} alt="Card holder" />;
};

export default CardHolder;
